import { breakpoints, Inline, LinkButton, Stack, vars } from '@etg/wings';
import { css } from '@eti/styles';
import { useSiteContext, useTranslation } from '@eti/providers';
import { focusOnFirstCharacteristicButton } from '../utils/SeatMapMainContentUtils';
import { addAislesToColumnDetails, addAislesToRows, addExitRows, isEmptyRow, isExitRow, isRowOverWing } from '../utils/layout';
import { skipButtonWrapperStyles } from '../utils/styles';
import ColumnDetails from './rowsandcolums/ColumnDetails';
import Row from './rowsandcolums/Row';
import RowContent from './rowsandcolums/RowContent';
import { useGetSeatIcons } from './rowsandcolums/hooks/useGetSeatIcons';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const keyboardOnlyButtonStyles = css`
  pointer-events: auto;
`;
const keyboardOnlyAllocatedSpaceStyles = css`
  display: block;
  font-size: 0.875rem;
  font-weight: ${vars.button.fontWeight};
  min-width: 120px;
  padding: 0 12px;
  visibility: hidden;

  @media (max-width: ${breakpoints._768}) {
    display: none;
  }
`;
const SeatMapCabin = _ref => {
  let {
    activeSegment,
    carrier,
    isRyanairInTrip,
    isSkipButtonFocused,
    onChange,
    onSkipButtonFocus,
    rows = [],
    seatTravelers,
    sellSeatMapColumnDetails = []
  } = _ref;
  const {
    brand
  } = useSiteContext();
  const {
    t
  } = useTranslation();
  const columnsWithAisles = addAislesToColumnDetails(sellSeatMapColumnDetails);
  const rowsWithAisles = addAislesToRows(rows, columnsWithAisles);
  const seatIcons = useGetSeatIcons(brand.code);
  const transformedRowData = addExitRows(rowsWithAisles);
  const handleOnSkipButtonFocus = isFocused => () => {
    onSkipButtonFocus(isFocused);
  };
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: 0,
    children: [/*#__PURE__*/_jsx(ColumnDetails, {
      details: columnsWithAisles,
      isOverWing: transformedRowData !== null && transformedRowData !== void 0 && transformedRowData[0] ? isRowOverWing(transformedRowData[0]) : false
    }), transformedRowData === null || transformedRowData === void 0 ? void 0 : transformedRowData.map((row, index) => {
      var _row$sellSeatMapSeats, _row$sellSeatMapSeats2;
      const hasExitArrow = (_row$sellSeatMapSeats = (_row$sellSeatMapSeats2 = row.sellSeatMapSeats) === null || _row$sellSeatMapSeats2 === void 0 ? void 0 : _row$sellSeatMapSeats2.some(seat => (seat === null || seat === void 0 ? void 0 : seat.type) === 'EXIT_ARROW')) !== null && _row$sellSeatMapSeats !== void 0 ? _row$sellSeatMapSeats : false;
      const shouldRenderLinkButton = !hasExitArrow;
      return /*#__PURE__*/_jsxs(Row, {
        isEmptyRow: isEmptyRow(row),
        isOverWing: isRowOverWing(row),
        children: [/*#__PURE__*/_jsx(RowContent, {
          activeSegment: activeSegment,
          carrier: carrier,
          isEmptyRow: isEmptyRow(row),
          isExitRow: isExitRow(row),
          isRyanairInTrip: isRyanairInTrip,
          onChange: onChange,
          seatIcons: seatIcons,
          seatTravelers: seatTravelers,
          sellSeatMapSeats: row.sellSeatMapSeats
        }), shouldRenderLinkButton && /*#__PURE__*/_jsxs(Inline, {
          align: "end",
          alignY: "center",
          className: skipButtonWrapperStyles(isSkipButtonFocused),
          noWrap: true,
          spacing: 16,
          children: [/*#__PURE__*/_jsx(LinkButton, {
            className: keyboardOnlyButtonStyles,
            "data-testid": "accessibilitySkipToNextSegment",
            onBlur: handleOnSkipButtonFocus(false),
            onClick: focusOnFirstCharacteristicButton,
            onFocus: handleOnSkipButtonFocus(true),
            children: t('Product.SeatMap.Accessibility.SkipToSeatMapLegend.Text')
          }), /*#__PURE__*/_jsx("span", {
            "aria-hidden": "true",
            className: keyboardOnlyAllocatedSpaceStyles,
            role: "presentation",
            tabIndex: -1,
            children: t('Product.SeatMap.Button.Continue')
          })]
        })]
      }, `row_${index}`);
    })]
  });
};
export default SeatMapCabin;
//# sourceMappingURL=SeatMapCabin.js.map